import api from '../services/api';
import { getSiteId } from '../siteId/siteId';

const DIGITAL_PRODUCT_ASSETS_URL = '/digitalUserAsset/v2';
const STORED_ARTWORK_FILES_URL = '/storedArtworkFiles/v2';

const digitalProductAssetsService = {
    getUserLibrary,
    getS3Url,
};

export default digitalProductAssetsService;

async function getUserLibrary (params) {
    return api({
        url: `${DIGITAL_PRODUCT_ASSETS_URL}/library`,
        method: 'GET',
        params: {
            ...params,
            siteId: getSiteId(),
        },
    });
}

async function getS3Url (id) {
    return api({
        url: `${STORED_ARTWORK_FILES_URL}/${id}/DIGITAL`,
        method: 'GET',
    });
}
